'use client';

import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { useParams } from 'next/navigation';
import { pdpPhasesOptions } from '@/api/queries/pdpPhases';
import { MetaDataParams, PdpPhaseDTO } from '@/types/models';
export function usePdpPhases(): UseQueryResult<PdpPhaseDTO[]> {
  const params = useParams<MetaDataParams>();
  const id = params.slug?.[0] || params.id;
  return useQuery(pdpPhasesOptions(id as string));
}